import React from "react";
import MaterialTextureLoader from "../loaders/MaterialTextureLoader";
import {mapMaterialProps} from './MaterialPropertyMaps';

const MaterialController = (item, newTextureSet, newMaterialProps, location) => {
  
  // load new texture set - format props - apply to material
  const materialsPrototypes = Object.values(item.mats);
  
  MaterialTextureLoader(location, newTextureSet, newMaterialProps, (newTextures) => {
    
    // each material sharing the same texture set
    materialsPrototypes.forEach((material) => {
      
      // apply textures
      newTextures.forEach((texture) => {
        texture.flipY = false;
        material[texture.name] = texture;
      });
      
      
      // apply material props
      const mapMatProps = mapMaterialProps();
      
      Object.keys(newMaterialProps).forEach((prop) => {
        
        if (!mapMatProps.get(prop)) {
          material[prop] = newMaterialProps[prop];
        } else {
          material[prop] = (mapMatProps.get(prop)(newMaterialProps[prop]));
        }
      });
      
      material.needsUpdate = true;
      
    });
  });
  
}

export default MaterialController;
